import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Studium} from './model/studium';
import {Subject} from 'rxjs';
import {ZapisnyList} from './model/zapisnyList';
import {TranslateService} from '@ngx-translate/core';
import {Znamka} from './model/znamka';
import {Skuska} from './model/skuska';
import {PriebezneHodnotenie} from './model/PriebezneHodnotenie';
import {PriebezneHodnotenieGroup} from './model/PriebezneHodnotenieGroup';
import {PrehladStudia} from './model/PrehladStudia';
import {Upozornenie} from './model/Upozornenie';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogComponent, ErrorDialogComponent, OkDialogComponent} from 'ais-common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ComponentType} from '@angular/cdk/portal';
import {Priemery} from './model/Priemery';
import {Config} from './model/Config';
import {PredmetPonuka} from './model/PredmetPonuka';
import {DataResponse} from './model/DataResponse';
import {Predmety} from './model/Predmety';
import {CastStudijnehoPlanu} from './model/CastStudijnehoPlanu';
import {SCESHodnotenie} from './model/SCESHodnotenie';

@Injectable({
  providedIn: 'root'
})
export class AppService
{
    private zapisneListy: Studium[] = null;
    public zapisneListySubject: Subject<Studium[]> = new Subject<Studium[]>();
    private zapisnyListSelected: ZapisnyList;
    public zapisnyListSubject: Subject<ZapisnyList> = new Subject<ZapisnyList>();
    public configLoader: Subject<Config> = new Subject<Config>();

    private selectedSemester = ['Z', 'L'];
    private znamky: Znamka[];
    private castiSp: CastStudijnehoPlanu[];

    znamkySubject = new Subject<Predmety>();
    skuskySubject = new Subject<Skuska[]>();
    priebezneHodnotenieSubject = new Subject<PriebezneHodnotenieGroup[]>();
    prehladySubject = new Subject<PrehladStudia[]>();
    priemerySubject = new Subject<Priemery>();
    upozorneniaSubject = new Subject<Upozornenie[]>();

  private skusky: Skuska[];
  private priebezneHodnotenie: PriebezneHodnotenieGroup[];
  private prehlady: PrehladStudia[];
  private priemery: Priemery;
  private upozornenia: Upozornenie[] = [];
  private idZapisnyList: number = null;

  private config: Config = null;
  private predmetyPonuka: PredmetPonuka[] = [];
  public predmetyPonukaSubject = new Subject<PredmetPonuka[]>();
  private predmetyPonukaLoading = false;
  public predmetyPonukaLoadingSubject = new Subject<boolean>();
  private red = false;

    private kdeSomPrihlaseny = true;
    private kdeSaMozemPrihlasit = true;



  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private modalService: MatDialog,
    private snackBar: MatSnackBar,
    private translation: TranslateService
  ) {
  }

  fetchZapisneListy()
  {
      if (this.zapisneListy !== null) {
          this.zapisneListySubject.next(this.zapisneListy);
      }
      else {
          this.http.get<DataResponse>('/ais/rest/portal/student-predmety/studia?lng=' + this.translate.currentLang)
              .subscribe({
                  next: (res) => {
                      this.zapisneListy = res.data;
                      this.zapisneListySubject.next(this.zapisneListy);
                  },
                  error: (error) => {
                      console.error(error);
                  }
              });
      }
  }

  setZapisnyListSelected(zapisnyList: ZapisnyList)
  {

    if (!zapisnyList) {
      return;
    }

    this.zapisnyListSelected = zapisnyList;
    this.zapisnyListSubject.next(zapisnyList);
    if (zapisnyList && zapisnyList.id) {
      this.retrieveConfig(zapisnyList.id);
    }

    this.fetchPredmety();

    this.http.get<Skuska[]>(
      '/ais/rest/portal/student-predmety/skusky/' + zapisnyList.id + '/v2')
      .subscribe({
        next: (data) => {
          this.skusky = data;
          this.skuskySubject.next(data);
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {}
    });

    this.http.get<PriebezneHodnotenie[]>(
      '/ais/rest/portal/student-predmety/priebezne-hodnotenie/' + zapisnyList.id)
      .subscribe(
        (data) => {
          this.priebezneHodnotenie = this.parsePriebezneHodnotenieGroups(data);
          this.priebezneHodnotenieSubject.next(
            this.getPriebezneHodnotenieBySemester(this.priebezneHodnotenie)
          );
        },
        (error) => {
          console.error(error);
        },
        () => {}
      );

    this.http.get<PrehladStudia[]>(
      '/ais/rest/portal/student-predmety/studium-prehlad/' + zapisnyList.id)
      .subscribe(
        (data) => {
          this.prehlady = data;
          this.prehladySubject.next(this.getPrehlady());
        },
        (error) => {
          console.error(error);
        },
        () => {}
      );

    this.http.get<Priemery>(
      '/ais/rest/portal/student-predmety/studium-priemery/' + zapisnyList.id)
      .subscribe(
        (data) => {
          this.priemery = data;
          this.priemerySubject.next(this.getPriemery());
        },
        (error) => {
          console.error(error);
        },
        () => {}
      );

    this.http.get<Upozornenie[]>(
      '/ais/rest/portal/student-predmety/upozornenia/' + zapisnyList.id)
      .subscribe({
          next: (data) => {
              this.upozornenia = data;
              this.upozorneniaSubject.next(this.upozornenia);
          },
          error: (error) => {
              console.error(error);
          },
          complete: () => {
          }
      });

    this.predmetyPonuka = [];
    this.predmetyPonukaSubject.next([]);
  }

  setSelectedSemester(kodSemester: string[]) {

    this.selectedSemester = kodSemester;

    const predmety = new Predmety();
    predmety.castiStudijnehoPlanu = this.castiSp;
    predmety.znamky = this.getZnamkyBySemester(this.znamky);

    this.znamkySubject.next(predmety);

    this.skuskySubject.next(this.skusky);

    this.priebezneHodnotenieSubject.next(
      this.getPriebezneHodnotenieBySemester(this.priebezneHodnotenie)
    );
  }

  private getZnamkyBySemester(znamky: Znamka[]) {
    if (!znamky) {
      return znamky;
    }
    return znamky.filter(
      z => (
        z.kodSemester === null
        || this.selectedSemester.length === 2
        || this.selectedSemester.includes(z.kodSemester)
      )
    );
  }

  getSkusky() {
    return this.skusky;
  }

  getPriebezneHodnotenie() {
    return this.getPriebezneHodnotenieBySemester(this.priebezneHodnotenie);
  }

  private getPriebezneHodnotenieBySemester(data: PriebezneHodnotenieGroup[]) {

    if (!data) {
      return null;
    }

    return data.filter(
      h => (
        this.selectedSemester.includes(h.kodSemester)
        || this.selectedSemester.length === 2
      )
    );
  }

  private parsePriebezneHodnotenieGroups(data: PriebezneHodnotenie[]): PriebezneHodnotenieGroup[] {
    const out: PriebezneHodnotenieGroup[] = [];

    data.forEach((h) => {
      const group = out.find(i => i.id === h.id);
      if (group) {
        group.addItem(h);
      }
      else {
        out.push(new PriebezneHodnotenieGroup(h));
      }
    });

    return out;
  }

  openErrorDialog(message) {
    return this.modalService.open(
      ErrorDialogComponent, {
        data: {
          message
        }
      });
  }

  getPrehlady() {
    return this.prehlady;
  }

  getPriemery() {
    return this.priemery;
  }

  getUpozornenia() {
    return this.upozornenia;
  }

  openConfirmDialog(message: string)
  {
    return this.modalService.open(
      ConfirmDialogComponent, {
        data: {
          message
        }
      });
  }

  openOkDialog(message: string): MatDialogRef<OkDialogComponent>
  {
    return this.modalService.open(
      OkDialogComponent, {
        data: {
          message
        }
      });
  }

  setSkusky(data: Skuska[]) {
    this.skusky = data;
    this.skuskySubject.next(this.skusky);
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 2000,
      panelClass: 'app-snack-bar'
    });
  }

  setIdZapisnyList(idZL: number) {
    this.idZapisnyList = idZL;
    this.retrieveConfig(idZL);
  }

  getIdZapisnyList() {
    return this.idZapisnyList;
  }

  getSemester() {
    return this.selectedSemester;
  }

  getZnamky() {
    return this.getZnamkyBySemester(this.znamky);
  }

  getIdPredmetZapisnyList(idPredmet: number): number {
    if (this.skusky) {
      const skuska = this.skusky.find(s => s.idPredmet === idPredmet);
      return skuska.idPredmetZl ?? null;
    }
    return null;
  }

  openDialog(cmp: ComponentType<any>)
  {
    return this.modalService.open(cmp);
  }

  setKdeSomPrihlaseny(kdeSomPrihlaseny: boolean) {
    this.kdeSomPrihlaseny = kdeSomPrihlaseny;
  }

  getKdeSomPrihlaseny(): boolean {
    return this.kdeSomPrihlaseny;
  }

  getConfig(): Config {
    if (!this.config && this.idZapisnyList) {
      this.retrieveConfig(this.idZapisnyList);
    }
    return this.config;
  }

  getZapisnyListSelected(): ZapisnyList {
    return this.zapisnyListSelected;
  }

  setPredmety(data: Predmety)
  {
    this.znamky = data.znamky;
    this.castiSp = data.castiStudijnehoPlanu;

    const predmety = new Predmety();
    predmety.castiStudijnehoPlanu = this.castiSp;
    predmety.znamky = this.getZnamkyBySemester(this.znamky);

    this.znamkySubject.next(predmety);
  }

  fetchPredmety() {

    if (!this.zapisnyListSelected || !this.zapisnyListSelected.id) {
      return;
    }

    this.http.get<Predmety>(
      '/ais/rest/portal/student-predmety/znamky/' + this.zapisnyListSelected.id, {
        headers: {
          f4XB27Zb3RFatc4: 'f4XB27Zb3RFatc4'
        }
      }
    )
      .subscribe({
        next: (data) => {
          this.znamky = data.znamky;
          this.castiSp = data.castiStudijnehoPlanu;

          const predmety = new Predmety();
          predmety.castiStudijnehoPlanu = this.castiSp;
          predmety.znamky = this.getZnamkyBySemester(this.znamky);

          this.znamkySubject.next(predmety);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  fetchPredmetyPonuka() {

    if (this.predmetyPonuka.length === 0)
    {
      this.predmetyPonukaLoading = true;
      this.predmetyPonukaLoadingSubject.next(this.predmetyPonukaLoading);

      this.http.get<PredmetPonuka[]>(
          '/ais/rest/portal/student-predmety/predmety-ponuka/' + this.zapisnyListSelected.id)
          .subscribe(
              (data) => {
                this.predmetyPonuka = data;
                this.predmetyPonukaSubject.next(this.predmetyPonuka);
              },
              (error) => {
                console.error(error);
              },
              () => {
                this.predmetyPonukaLoading = false;
                this.predmetyPonukaLoadingSubject.next(this.predmetyPonukaLoading);
              }
          );
    }
  }

  getPredmetyPonuka() {
    return this.predmetyPonuka;
  }

  getPredmetyPonukaLoader() {
    return this.predmetyPonukaLoading;
  }

  setRed(red: boolean) {
    this.red = red;
  }

  getRed(): boolean {
    return this.red;
  }

  getCastiSP() {
    return this.castiSp;
  }

  private retrieveConfig(idZL: number) {
    if (idZL) {
      this.http.get<Config>('/ais/rest/portal/student-predmety/config/' + idZL)
        .subscribe({
          next: (data) => {
            this.config = data;
            this.configLoader.next(this.config);
          },
          error: (error) => {
            console.error(error);
          }
        });
    }
  }

  prihlasit(skuska: Skuska)
  {
    const msg3 = this.translation.instant('Súhlasíte so zverejnením vášho mena v zozname prihlásených študentov?');

    const dialogRef3 = this.openConfirmDialog(msg3);

    dialogRef3.afterClosed().subscribe(
        (res3) => {

            if (res3 === undefined) {
                return;
            }

          const idPredmetZl = this.getIdPredmetZapisnyList(skuska.idPredmet);

          this.http.post(
              '/ais/rest/portal/student-predmety/termin/' + skuska.id + '/student/' + idPredmetZl,
              null,
              {
                params: {
                  zverejnit: (res3 === 'OK' ? 'true' : 'false')
                }
              }
          ).subscribe({
            next: (data: Skuska[]) => {
              this.setSkusky(data);
              dialogRef3.close();
              this.openSnackBar(
                  this.translation.instant('Boli ste prihlásený na termín')
              );
            },
            error: (error) => {
              this.openErrorDialog(error.error.message);
            }
          });
        });
  }

  refreshPredmety() {
    this.fetchPredmety();
  }

    getKdeSaMozemPrihlasit() {
        return this.kdeSaMozemPrihlasit;
    }

    setKdeSaMozemPrihlasit(kdeSaMozemPrihlasit: boolean) {
        this.kdeSaMozemPrihlasit = kdeSaMozemPrihlasit;
    }

    getPopisHodnotenia(kodHodnotenia: string)
    {
        if (this.config?.hodnotenia?.length) {
            const match = this.config.hodnotenia.find((h: SCESHodnotenie) => h.kod === kodHodnotenia);
            if (match?.skratPopis) {
                return match.skratPopis;
            }
        }

        return null;
    }

    getZapisneListy(): Studium[]
    {
        return this.zapisneListy;
    }

    odhlasit(skuska: Skuska)
    {
        this.http.delete('/ais/rest/portal/student-predmety/termin/' + skuska.id + '/student/' + skuska.idPredmetZl)
            .subscribe({
                next: (data: Skuska[]) => {
                    this.setSkusky(data);
                    this.openSnackBar(
                        this.translation.instant('Boli ste odhlásený z termínu')
                    );
                },
                error: (error) => {
                    this.openErrorDialog(error.error.message);
                }
            });
    }

    getZapisnyList(elZapisAkRok: string)
    {
        let findZL = null;

        this.zapisneListy.forEach(s => {
            s.zapisneListy.forEach(zl => {
                if (zl.akRok === elZapisAkRok) {
                    findZL = zl;
                }
            });
        });

        return findZL;
    }
}
